/**
 * Memes 表格常量配置
 */

// Meme 类型的颜色映射
export const MEME_TYPE_COLORS: Record<
  string,
  { backgroundColor: string; color: string }
> = {
  default: { backgroundColor: '#EDE3F9', color: '#8E51DA' },
};

// Meme 元素的颜色映射
export const MEME_ELEMENT_COLORS: Record<
  string,
  { backgroundColor: string; color: string }
> = {
  default: { backgroundColor: '#DBF1F1', color: '#1FA6AA' },
};

// 表头 Tooltip 信息 - 使用 TipsMapType 的 en/zh 格式
export const VIEWS_HEADER_TIP = {
  en: 'Total views of videos released within the selected period that rank in the all-time Top 500 by views.',
  zh: '所选时间范围内发布，且跻身历史观看量Top 500 的视频播放总量',
};

export const LIKES_HEADER_TIP = {
  en: 'Total likes on videos released within the selected period that rank in the all-time Top 500 by likes.',
  zh: '所选周期内发布，且跻身历史观看量Top 500 的视频点赞总量',
};

export const MEME_TREND_TIP = {
  en: 'Total views and count of videos released within the selected period that rank in the all-time Top 500 by views.',
  zh: '所选时间范围内发布，且跻身历史观看量 Top 500 的视频观看总量及总数',
};

// 排序选项配置 - 与 API sort_item 字段对齐: views, likes, first_seen, meme_type, meme_elements, channel
export const getSortOptions = (tabKey: 'views' | 'likes') => [
  {
    text: tabKey === 'views' ? 'Views' : 'Likes',
    value: tabKey,
  },
  { text: 'First Seen', value: 'first_seen' },
  { text: 'Meme Types', value: 'meme_type', order: 'asc' },
  { text: 'Meme Elements', value: 'meme_elements', order: 'asc' },
  { text: 'Channel', value: 'channel', order: 'asc' },
];
